// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1pj_Q","errorLogs":"EditorFooter_errorLogs__DPkUP"};